import { Database, ref, set } from 'firebase/database';

export const teachersCreate = async (
	database: Database,
	teacherName: string,
	subjects: string[] = []
): Promise<void> => {
	const normalizedName = teacherName.trim();

	if (!normalizedName) {
		return;
	}

	return set(ref(database, `teachers/${normalizedName}`), {
		name: normalizedName,
		subjects,
	});
};
